import { SVGProps } from "react";

export default function XTwitterIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, fill = "#20242A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_4263_22590)">
        <path
          d="M9.49711 6.77491L15.3254 0H13.9443L8.88358 5.88256L4.84162 0H0.179688L6.29193 8.89547L0.179688 16H1.56088L6.90511 9.78782L11.1737 16H15.8356L9.49677 6.77491H9.49711ZM7.60537 8.97384L6.98608 8.08805L2.05855 1.03974H4.17998L8.15656 6.72795L8.77585 7.61374L13.9449 15.0075H11.8235L7.60537 8.97418V8.97384Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_4263_22590">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
